import React from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { nanoid } from "nanoid";

import {
  useSetLocationData,
} from "~/hooks/locationData";
import s from "./TableRow.less";

interface IProps {
  options: string[];
  nameChildren?: string[];
  type: string;
  btnEdit?: boolean;
  btnView?: boolean;
  btnVersion?: boolean;
  btnDel?: boolean;
  item;
}

const ZDUsouoTableRow: React.FC<IProps> = ({
  options = [],
  item = {},
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const setData = useSetLocationData();
  const goToId = (e) => {
    history.push("/zd/main/");

    setData("event", item.DealerId, "page", "0");
  };

  return (
    <>
      <tr className={clsx(s.row_tr, s.row_td)}>
        {options?.map((optionName) => (
          <td
            style={{ maxWidth: 100, overflow: "hidden" }}
            key={nanoid()}
            data-option_name={optionName}
            onClick={goToId}
          >
            <div>
              <span className={s.cont}>{item[optionName]}</span>
            </div>
          </td>
        ))}
      </tr>
    </>
  );
};
export default ZDUsouoTableRow;
